









































































import Vue from 'vue'
export default Vue.extend({
  props: {
    productId: String,
    productTitle: String,
    categoryId: String,
    categoryTitle: String,
    postId: String,
    postTitle: String,
    showIcon: {
      type: Boolean,
      default: false
    },
    goBackIconColor: {
      type: String,
      default: '#111827'
    }
  },
  computed: {
    isPostRoute(): string {
      if (this.$route.name === 'post-overview') {
        return 'lessonPrimaryStyle breadCrumb__nav'
      }
      return ''
    },
    templateId(): string {
      return this.$route.query.template_id
    }
  }
})
